import {useFetchData} from 'hooks/api/useFetchData'
import {EmployeeAlertNotification} from 'types/api/employeeAlertsNotifications/employeeAlertNotifications'

export const useFetchEmployeeAlertNotifications = () => {
  const path = '/api/alert_notifications'
  return useFetchData<EmployeeAlertNotification[]>(path, [], {})
}
